<template>
    <div>
        <div>"{{templateArgs.instance.input.val()}}" - {{ templateArgs.context.$t('tags.not-found-add') }}</div>
        <button class="k-button" @click.prevent="addNew(templateArgs)">{{ templateArgs.context.$t('buttons.add') }}</button>'
    </div>
</template>

<script>
    export default {
        name: "tagNoDataTemplate",
        data () {
            return {
                templateArgs: {},
                itemText: 'template'
            }
        },
        methods: {
            addNew(elem) {
                let widget = elem.widget;
                let dataSource = elem.instance.dataSource;
                let newValue = elem.instance.input.val();

                dataSource.add({
                    text: newValue,
                    value: newValue
                });

                // Workaround für Kendo Bug
                setTimeout(function(){
                    widget.value(widget.value().concat([newValue]));
                }, 1);
            }
        }
    }
</script>

<style scoped>

</style>
